

import GroupController from './../../zviz2/zviz/components/group';
import Rectangle from './../../zviz2/zviz/components/rectangle';
import {Controller as ArcController} from './../../zviz2/zviz/components/arc';

import {extend} from './../../zviz2/zviz/functions';

//import {LifeCycle} from './../../lib/zviz/cycle';

class Controller extends ArcController{

    constructor(parent, blueprint={}){

        super(parent, Blueprint);

        this.blueprint = extend(blueprint, this.blueprint);

        this.scale = 0;

    }

    render(renderer){
        super.render(renderer);
        
        this.scale += renderer.delta / 1000;
        if(this.scale > 1){
            this.scale -= 1;
        }

        this.update();
    }


}


let Blueprint = {
    type: Controller,
    properties:{
        style: {
            'fill': '#555555',
            'fillOpacity': (ctrl) => ( (1 - ctrl.scale) ),
            'strokeWidth': '0px'
        },
        attributes: {
            'r': (ctrl) => ( (ctrl.scale * ctrl.data.size) ),
            'cx': 0,
            'cy': 0,
        },
        data: {
            size: 50,
        }
    }

};


export default Blueprint;
export {Blueprint};
